import './App.css';
import Nav from './components/Nav';
import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home';
import Menu from './pages/Menu';
import FindUs from './pages/FindUs';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import OrderNow from './pages/OrderNow';
import Rewards from './pages/Rewards';
import Careers from './pages/Careers';
import Blog from './pages/Blog';
import Nutrition from './pages/Nutrition';
import TermsPrivacy from './pages/TermsPrivacy';
import InteractiveMenu from './pages/InteractiveMenu';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Interactive Menu - No Nav/Footer */}
        <Route path='/interactive-menu' element={<InteractiveMenu />} />
        
        {/* Standard Routes with Nav/Footer */}
        <Route path='/*' element={
          <>
            <Nav />
            <Routes>
              {/* Home page wont have nav link. instead, home page will be linked to the logo in the header */}
              <Route path='/' element={<Home />} />
              <Route path='/menu' element={<Menu />} />
              <Route path='/find-us' element={<FindUs />} />
              <Route path='/rewards' element={<Rewards />} />
              <Route path='/order-now' element={<OrderNow />} />
              
              {/* Footer Routes */}
              <Route path='/about-us' element={<AboutUs />} />
              <Route path='/careers' element={<Careers />} />
              <Route path='/blog' element={<Blog />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/nutrition' element={<Nutrition />} />
              <Route path='/terms-privacy' element={<TermsPrivacy />} />
            </Routes>
            <Footer />
          </>
        } />
      </Routes>
    </div>
  );
}

export default App;